import { useEffect } from 'react'
import { useLocation } from 'wouter'

export const RedirectRoute = ({
    to,
    external,
}: {
    to: string
    external?: boolean
}): null => {
    const [, navigate] = useLocation()

    useEffect(() => {
        if (external) {
            if (typeof window !== 'undefined') {
                window.location.replace(to)
            }
        } else {
            navigate(to, { replace: true })
        }
    }, [to, external, navigate])

    return null
}
